export enum AssignmentPriority {
  Normal = 1,
  Urgent = 2,
}
